/* global options */

// Imports nuxt's middleware object from .nuxt build dir.
import Middleware from '../middleware.js';
import createMeta from './createMeta';

/**
 * Middleware is responsible for creating a store module at
 * $store.state.amplitude with userId and amplitude options.
 */

Middleware.amplitude = function(context) {
    if (process.client) {
        return;
    }

    const initialConfig = {
        enable: false,
        amplitudeKey: null,
        userId: null,
        configString: null,
        deviceId: (
            context.req.query?.amplitudeDeviceId ||
            context.req.body?.amplitudeDeviceId ||
            context.req.cookies?.amplitudeDeviceId
        ),
        secureCookie: true,
        cookieDomain: 'tidal.com',
    };

    const config = Object.assign(initialConfig, {
  "enable": true,
  "includeUtm": true,
  "includeReferrer": true,
  "saveParamsReferrerOncePerSession": true,
  "secureCookie": true,
  "cookieDomain": ".tidal.com"
});

    if (config.deviceId) {
        context.app.$cookies.set('amplitudeDeviceId', config.deviceId, {
            path: '/',
            maxAge: 60 * 60 * 24 * 365, // expires in a year
            secure: config.secureCookie,
            sameSite: 'lax',
            domain: config.cookieDomain,
        });
    }

    // Only process `req` on the server, where it's available.
    if (config.enable) {
        // Create string representation of the config.
        config.configString = configToString(config);
    }

    const head = context.app.head;
    const amplitudeHead = createMeta(config);

    if (!head.__dangerouslyDisableSanitizers) {
        head.__dangerouslyDisableSanitizers = [];
    }

    head.script = head.script.concat(amplitudeHead.script);
    head.link = head.link.concat(amplitudeHead.link);
    head.__dangerouslyDisableSanitizers = head.__dangerouslyDisableSanitizers.concat(amplitudeHead.__dangerouslyDisableSanitizers);
};

function configToString(config) {
    const configCopy = Object.assign({}, config);
    delete configCopy.enable;
    delete configCopy.amplitudeKey;

    if (configCopy.includeUtm === null || configCopy.includeUtm === undefined) {
        configCopy.includeUtm = true;
    }

    if (configCopy.includeReferrer === null || configCopy.includeReferrer === undefined) {
        configCopy.includeReferrer = true;
    }

    if (configCopy.saveParamsReferrerOncePerSession === null ||
        configCopy.saveParamsReferrerOncePerSession === undefined) {
        configCopy.saveParamsReferrerOncePerSession = true;
    }

    return JSON.stringify(configCopy);
}
